var React = require('react');

function Data (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 8H12C10.8954 8 10 7.10457 10 6V2M6 13V15.5C6 15.7761 6.22386 16 6.5 16H10M6 13V10.5C6 10.2239 6.22386 10 6.5 10H10M6 13H10M10 16H13.5C13.7761 16 14 15.7761 14 15.5V13M10 16V13M10 10H13.5C13.7761 10 14 10.2239 14 10.5V13M10 10V13M10 13H14M16 7.82843V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4C4 2.89543 4.89543 2 6 2H10.1716C10.702 2 11.2107 2.21071 11.5858 2.58579L15.4142 6.41421C15.7893 6.78929 16 7.29799 16 7.82843Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"square"}));
}

Data.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Data;

Data.default = Data;
